import { Box } from '@mentimeter/ragnar-ui/box';
import { scaleOrdinal } from 'd3-scale';
import { Text } from '@mentimeter/ragnar-ui/text';
import type {
  Visualization,
  ChoicesData,
  ChoicesStaticOptions,
} from '../types';

export const Dots = ({
  width,
  height,
  colors,
  data,
  staticOptions,
  disableAnimations,
  keyAccessor = (d: ChoicesData | ChoicesStaticOptions) => d.id.toString(),
  labelAccessor = (d: ChoicesStaticOptions) => d.label,
  valueAccessor = (d: ChoicesData) => d.score,
  isScoreHidden,
}: Visualization<ChoicesData, ChoicesStaticOptions> & {
  isScoreHidden: boolean;
}) => {
  const rootHeight = Math.max(height, 0);
  const rootWidth = Math.max(width, 0);

  const discreteValuesBasedOnId = staticOptions.map(keyAccessor);

  const fillColors = scaleOrdinal(colors).domain(discreteValuesBasedOnId);

  if (rootWidth <= 0 || rootHeight <= 0) {
    return null;
  }

  return (
    <Box
      width={rootWidth}
      height={rootHeight}
      justifyContent="center"
      alignItems="center"
      aria-hidden
    >
      <Box display="grid" gridTemplateColumns="repeat(3, 1fr)" gap={2}>
        {staticOptions.map((option, i) => (
          <Box
            key={option.id}
            width="100%"
            height="100%"
            bg={fillColors(option.id.toString())}
          >
            <Text>{JSON.stringify(option)}</Text>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
